export const SPORTS_SEO_KEYWORDS = [
  "مباريات اليوم",
  "نتائج مباريات اليوم",
  "مواعيد مباريات اليوم",
  "القنوات الناقلة للمباريات",
  "النتائج المباشرة",
  "أخبار كرة القدم",
  "أخبار الدوري المصري",
  "مباريات الدوري المصري",
  "ترتيب الدوري المصري",
  "أخبار الأهلي",
  "أخبار الزمالك",
  "أخبار بيراميدز",
  "مباريات الأهلي",
  "مباريات الزمالك",
  "ملخصات مباريات اليوم",
  "أهداف مباريات اليوم",
  "أخبار الدوري السعودي",
  "أخبار الدوري الإنجليزي",
  "أخبار الدوري الإسباني",
  "أخبار الدوري الإيطالي",
  "تشكيل الفريق",
  "تشكيل متوقع",
  "موعد المباراة",
  "نتيجة المباراة",
] as const;

export function buildSportsKeywords(parts: Array<string | null | undefined>) {
  const values = [...parts, ...SPORTS_SEO_KEYWORDS];
  return Array.from(new Set(values
    .flatMap((value) => (value ?? "").split(/[،,|•؛\n]+/))
    .map((value) => value.trim())
    .filter((value) => value.length >= 3)))
    .slice(0, 20);
}
